import React from "react";
import {connect} from "react-redux";
import List from '../../../components/CRM/List';
import {Datagrid, TextField} from "admin-on-rest";
import DateField from "../../../components/CRM/DateField";
import {listStyle} from "./style";
import ActionBar from "../../../components/CRM/ActionBar/";
import VirtualSlipFilter from "./VirtualSlipFilter";
import ActionMenu from "../../../components/CRM/ActionMenu";
import {refreshView as refreshViewAction} from "admin-on-rest";

class LinkFieldBase extends React.Component {
  handleLinkClick = () => {
    this.props.refreshView();
  };

  render() {
    const record = {...this.props.record};
    return (
      <a
        style={listStyle.linkStyle}
        href={record.short_url}
        onClick={this.handleLinkClick}
        target="blank"
      >
        {record.short_url}
      </a>
    );
  }
}

const LinkField = connect(
  null,
  {
    refreshView: refreshViewAction
  }
)(LinkFieldBase);

class VirtualSlipDataListBase extends React.Component {
  state = {
    selectedRow: [],
    selectedAll: "",
    selectedIds: []
  };

  componentDidMount() {
    if (this.props.configuration && this.props.configuration.virtualslips) {
      const {history} = this.props;
      if (this.props.configuration.virtualslips.enabled !== true)
        history.replace(`/`);
    }
  }

  componentDidUpdate(nextProps) {
    if (this.props.configuration !== nextProps.configuration) {
      const {history} = this.props;
      if (this.props.configuration.virtualslips.enabled !== true)
        history.replace(`/`);
    }
  }

  handleRowSelection = value => {
    if (Array.isArray(value)) {
      this.props.record.selectedRow = value;
    } else {
      this.props.record.selectedAll = value;
    }
    this.handleIdsSelection();
  };

  handleIdsSelection = () => {
    if (this.props.record.selectedAll === "none") {
      this.handleUnselectAll();
    } else {
      if (this.props.record.selectedAll === "all") {
        this.handleSelectAll();
      } else {
        if (
          this.props.record.selectedRow[0] ||
          this.props.record.selectedRow[0] === 0
        ) {
          this.handleSelectIds();
        } else {
          this.handleUnselectIds();
        }
      }
    }
  };

  handleUnselectAll = () => {
    this.props.record.ids = [];
    this.props.record.selectedAll = "";
    this.props.record.selectedRow = "";
    this.handleResetState();
    this.props.refreshView();
  };

  handleSelectAll = () => {
    this.props.record.ids = this.props.record.list.ids;
    this.props.record.selectedRow = [];
    this.props.record.selectedAll = "";
    this.handleResetState();
  };

  handleSelectIds = () => {
    this.props.record.list.ids.forEach((pair, index) => {
      this.props.record.selectedRow.forEach((value, key) => {
        if (value === index) {
          this.handleAddId(pair);
        }
        this.state.selectedIds.forEach((id, nb) => {
          if (id === pair) {
            if (!this.props.record.selectedRow.includes(index)) {
              this.handleRemoveId(id);
            }
          }
        });
      });
    });
  };

  handleAddId = pair => {
    if (this.state.selectedIds && !this.state.selectedIds.includes(pair)) {
      this.state.selectedIds.push(pair);
      this.props.record.ids = this.state.selectedIds;
    }
  };

  handleRemoveId = id => {
    function remove(array, element) {
      const index = array.indexOf(element);

      if (index !== -1) {
        array.splice(index, 1);
      }
    }
    remove(this.state.selectedIds, id);
    this.props.record.ids = this.state.selectedIds;
  };

  handleUnselectIds = () => {
    this.props.record.ids = [];
    this.props.record.selectedRow = [];
    this.handleResetState();
    this.props.refreshView();
  };

  handleResetState = () => {
    this.setState({
      selectedIds: [],
      selectedAll: "",
      selectedRow: []
    });
  };

  render() {
    const props = {...this.props};

    return (
      <List
        title="resources.virtualSlips.name"
        {...props}
        actions={<ActionBar {...props} />}
        sort={{field: "expert", order: "ASC"}}
        filters={<VirtualSlipFilter />}
      >
        <Datagrid
          options={{
            multiSelectable: true,
            selectable: true,
            onRowSelection: this.handleRowSelection
          }}
          headerOptions={{
            adjustForCheckbox: true,
            displaySelectAll: true,
            enableSelectAll: true
          }}
          bodyOptions={{
            displayRowCheckbox: true,
            deselectOnClickaway: false,
            showRowHover: true
          }}
          rowOptions={{
            selectable: true
          }}
        >
          <TextField
            label="resources.virtualSlips.fields.storeName"
            source="store_name"
          />

          <TextField
            label="resources.virtualSlips.fields.betType"
            source="type"
            style={listStyle.textFieldStyle}
          />

          <TextField
            label="resources.virtualSlips.fields.expert"
            source="expert"
          />

          <DateField
            label="resources.virtualSlips.fields.startDate"
            source="start_date"
          />
          <DateField
            label="resources.virtualSlips.fields.closingTime"
            source="closing_time"
          />
          <LinkField
            label="resources.virtualSlips.fields.link"
            source="short_url"
          />
          <DateField
            label="resources.virtualSlips.fields.createdAt"
            source="created_at"
          />

          <ActionMenu />
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    record: state.admin.resources[props.resource],
    configuration: state.configuration
  };
};

const VirtualSlipDataList = connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(VirtualSlipDataListBase);

export default VirtualSlipDataList;



// WEBPACK FOOTER //
// ./src/containers/CRM/VirtualSlips/VirtualSlipDataList.js